// @flow

import * as React from "react";
import { ReactForm } from "@adrenalin/react-form";

import useMergableState from "../../hooks/useMergableState";
import SharedFilterFunctions from "./SharedFilterFunctions";

type PropsType = {
    data: any,
    resetUrl: string,
};

const VenueListingFilters = (props: PropsType): React.Node => {
    // Pull out data from props
    const {
        search,
        setting,
        capacity,
        suburb,
        features,
        type: venueType,
        occasion,
    } = props.data;

    // State vars
    const [inputState, setInputState] = useMergableState({
        [search.name]: search.value,
    });

    // Create our shared functions using the factory
    const {
        createFilterGroup,
        renderFilterActions,
        filterGroupLooper,
        renderSearchField,
    } = new SharedFilterFunctions(
        inputState,
        setInputState,
        "Venue Listing Filters"
    );

    // Build an array of filterGroups
    const filterGroups = [
        createFilterGroup("radio", "Venue setting", setting),
        createFilterGroup("radio", "Capacity", capacity, { columns: 2 }),
        createFilterGroup("checkbox", "Suburb", suburb),
        createFilterGroup("checkbox", "Features", features),
        createFilterGroup("checkbox", "Venue type", venueType),
        createFilterGroup("checkbox", "Occasion", occasion),
    ];

    // Render
    return (
        <div className="filters__outer">
            <ReactForm pageSubmit disableErrorScroll>
                <div className="filters__inner">
                    <div className="filters__inputs">
                        {/* Search field */}
                        <div className="filters__search">
                            {renderSearchField(search.name)}
                        </div>

                        {/* Filter groups */}
                        <div className="filters__accordions">
                            {filterGroupLooper(filterGroups)}
                        </div>
                    </div>
                    {renderFilterActions(props.resetUrl)}
                </div>
            </ReactForm>
        </div>
    );
};

export default VenueListingFilters;
